<template>
  <div v-if="wordDetailsStore.isWordSelected" class="word-details-overlay">
    <div class="word-details-container">
      <div class="word-details-content">
        <button class="close-button" @click="handleClose">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
        
        <div class="word-details" v-if="selectedWord">
          <span class="word-text">
            {{ selectedWord.primaryWord }}<template v-if="selectedWord.transliteration"> [{{ selectedWord.transliteration }}]</template> - {{ selectedWord.secondaryWord }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { wordDetailsStore } from '../../store/wordDetailsStore'
import { useEscapeKey } from '../../composables/useEscapeKey'

const selectedWord = computed(() => wordDetailsStore.getSelectedWord().value)

const handleClose = () => {
  wordDetailsStore.clearSelectedWord()
}

useEscapeKey({
  isActive: () => wordDetailsStore.isWordSelected,
  onEscape: handleClose,
  priority: 100
})
</script>

<style scoped lang="less">
.word-details-overlay {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: none;
  margin: auto;
  max-width: 600px;
}

.word-details-container {
  display: flex;
  justify-content: center;
  padding: 16px;
  padding-bottom: 5px;
  pointer-events: none;
}

.word-details-content {
  background: white;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.08);
  width: 100%;
  position: relative;
  pointer-events: all;
  backdrop-filter: blur(8px);
}

.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: all 0.2s ease;
  width: 24px;
  height: 24px;
}

.close-button:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #333;
}

.close-button:active {
  background: rgba(0, 0, 0, 0.1);
  transform: scale(0.95);
}

.word-details {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 32px; /* Space for close button */
}

.word-text {
  font-size: 16px;

  color: #333;
  line-height: 1.4;
  text-align: center;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .word-details-overlay {
    max-width: 100%;
  }

  .word-details-container {
    padding: 10px;
  }

  .word-details-content {
    padding: 10px 14px;
    border-radius: 6px;
  }

  .word-text {
    font-size: 15px;
  }

  .close-button {
    width: 20px;
    height: 20px;
    top: 6px;
    right: 6px;
  }

  .close-button svg {
    width: 16px;
    height: 16px;
  }
}

@media (max-width: 480px) {
  .word-details-container {
    padding: 8px;
  }

  .word-details-content {
    padding: 8px 12px;
  }

  .word-text {
    font-size: 14px;
  }

  .close-button {
    width: 18px;
    height: 18px;
  }

  .close-button svg {
    width: 14px;
    height: 14px;
  }
}
</style>
